import animateScroll from './animate-scroll';

$('.js-btn-scroll').on('click', function(e) {
	e.preventDefault();

	const $this = $(this);

	const $element = $($this.attr('href'));

	animateScroll($element);
});
